import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Update, GetById } from "adminApi/Terms&PrivacySocialApi/ServiceLinks";
import { validateForm } from "utils/validation";
import { ServiceLinksRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditServiceLinksForm from "./Componates/EditServiceLinksForm";
import fields from "../json/TermsAndPrivacyFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const EditServiceLinks = () => {
  const navigate = useNavigate();
  const { formdataservice } = fields;
  const { id } = useParams();

  // Initialize default field values
  const initialValues = formdataservice.reduce(
    (acc, field) => ({ ...acc, [field.name]: "" }),
    {}
  );

  const {
    values,
    errors,
    handleChange,
    handleFileChange,
    setErrors,
    setValues,
  } = useFormChange(initialValues, ServiceLinksRules);

  // Fetch data by ID
  const { loading: loadingFetch } = useFetchFormDataById(
    id,
    formdataservice,
    GetById,
    setValues
  );

  // Form submit
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => {
        formData.append(key, val ?? "");
      });
      return await Update({ id, data: formData });
    },
    (vals) => {
      // remove icon key if it's a string (already uploaded)
      if (typeof vals.icon === "string") {
        delete vals.icon;
      }
      const err = validateForm(vals, ServiceLinksRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Service links updated successfully"
  );

  return (
    <>
      {(loadingFetch || loadingSubmit) && <Spinner isSpinner={true} />}
      <EditServiceLinksForm
        fields={formdataservice}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleFileChange={handleFileChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        imagePreview={
          values.iconPreview ||
          (values.icon && values.icon)
        }
        title="Update Service Links"
      />
    </>
  );
};

export default EditServiceLinks;
